const SelectComponent = ({
    title,
    selectItem = [],
    value,
    handleChange,
    minWidth,
    disabled = false,
    className = '',
    ariaLabel,
}) => {
    return (
        <div
            className={['selectContainer', className].filter(Boolean).join(' ')}
            style={minWidth ? { ['--minw']: `${minWidth}px` } : undefined}
        >
            {title ? <label className="selectContainer__label">{title}</label> : null}

            <div className="selectContainer__wrap">
                <select
                    className="selectContainer__select"
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    aria-label={ariaLabel || title || 'Выбор'}
                >
                    {selectItem.map((item, i) => (
                        <option key={`${item.value}-${i}`} value={item.value}>
                            {item.text ?? item.value}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}

export default SelectComponent
